import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable @typescript-eslint/naming-convention */
import { format, isEqual } from 'date-fns';
import { useContext } from 'preact/compat';
import DatesCTX from '@widgets/shared/components/CustomDatepicker/context/dates';
import { Number, Price, Wrapper } from './styles';
function DatepickerDay(_, date) {
    const { availablePrices, lowAvailabilityDates, selectedDate } = useContext(DatesCTX);
    if (!date)
        return null;
    const dateString = format(date, 'yyyy-MM-dd');
    const month = date.getUTCMonth();
    const isLowAvailability = lowAvailabilityDates.includes(dateString);
    const isSelected = isEqual(date, selectedDate ?? new Date());
    const foundPrice = availablePrices.find((price) => price.date === dateString);
    return (_jsxs(Wrapper, { className: `month-${month}`, lowAvailability: isLowAvailability, selected: isSelected, children: [_jsx(Number, { children: format(date, 'd') }), _jsx(Price, { dangerouslySetInnerHTML: { __html: foundPrice?.price ? `£${foundPrice.price}` : '&nbsp;' } })] }));
}
export default DatepickerDay;
